import React from 'react';

const context = React.createContext([] as Array<any>);

export default context;
